import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit/root';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from '../../types/applicationContext';
import { IReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { PageContainer } from '../Page';
import { useLocationChange, useLocationInit } from '../../hooks/browserHistory';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  useLocationInit(reduxStore);
  useLocationChange(reduxStore);

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <PageContainer />
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
